export default __webpack_public_path__ + "static/media/Barcelona-Orange.0e3b3104.jpg";